export const formatDate = (date: string) => {
    const dateObject = new Date(date);
    return new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour12: false,
    }).format(dateObject);
  };